<template>
  <div class="channel-line-body">
    <div class="channel-line-body-child">
      <ul class="channel-line-category">
        <li v-for="item in constant.linetypes" :key="item.value" :class="[item.value === activevalue?'active':'','fl']" @click="linetypeClick(item)">
          {{item.label}}线路
        </li>
        <li class="clear"></li>
      </ul>
      <table class="channel-line-search">
        <tr>
          <td style="width:70px;">揽件地区：</td>
          <td>
            <el-cascader size="mini" placeholder="请选择所在地区" :options="regionmodule.regions" v-model="regionline.regions" filterable clearable change-on-select class="el-width-300"></el-cascader>
            <el-select size="mini" :placeholder="请选择仓库类型" v-show="regionline.depottypeshow" v-model="regionline.depottype" filterable class="el-width-100" @change="depotTypeChange">
              <el-option v-for="item in constant.depottypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
            </el-select>
            <el-select size="mini" v-show="activevalue !== '0' && activevalue != '3'" :placeholder="'请选择'+regionline.shipmentlabel" v-model="regionline.shipmentid" class="el-width-200" filterable>
              <el-option v-for="item in regionline.datalist" :key="item.value" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </td>
        </tr>
        <tr>
          <td>目的国家：</td>
          <td>
            <el-select size="mini" placeholder="请选择目的国家" v-model="regionline.purposeregion" filterable clearable class="el-width-300">
              <el-option v-for="item in purposeregions" :key="item.value" :value="item.value" :label="item.label"></el-option>
            </el-select>
            <el-select size="mini" v-show="activevalue !== '0'" :placeholder="'请选择'+regionline.purposelabel" v-model="regionline.purposeid" class="el-width-200" filterable>
              <el-option v-for="item in regionline.datalist" :key="item.value" :value="item.value" :label="item.label" :disabled="item.value === regionline.shipmentid"></el-option>
            </el-select>
          </td>
        </tr>
        <tr>
          <td>货物信息：</td>
          <td>
            <ul class="fl">
              <li v-for="(item,index) in regionline.parcellist" :key="index">
                长
                <el-input size="mini" type="number" v-model="item.long" class="el-width-100">
                  <template slot="append">cm</template>
                </el-input>
                宽
                <el-input size="mini" type="number" v-model="item.wide" class="el-width-100">
                  <template slot="append">cm</template>
                </el-input>
                高
                <el-input size="mini" type="number" v-model="item.high" class="el-width-100">
                  <template slot="append">cm</template>
                </el-input>
                重量
                <el-input size="mini" type="number" v-model="item.weight" class="el-width-100">
                  <template slot="append">kg</template>
                </el-input>
                <template v-if="index === 0">
                  <el-tooltip content="添加更多货物信息" placement="top">
                    <el-button size="mini" icon="el-icon-plus" circle @click="insertRegionParcelClick"></el-button>
                  </el-tooltip>
                </template>
                <template v-if="index > 0">
                  <el-tooltip content="删除货物信息" placement="top">
                    <el-button size="mini" type="danger" icon="el-icon-close" circle @click="deleteRegionParcelClick(index)"></el-button>
                  </el-tooltip>
                </template>
              </li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>货物属性：</td>
          <td>
            <el-radio-group v-model="regionline.parcelattribute" size="mini">
              <el-radio-button v-for="item in parcelattributes" :key="item.value" :label="item.value">{{item.label}}</el-radio-button>
            </el-radio-group>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <el-button size="mini" type="success" icon="el-icon-search" class="fr" @click="regionLineSearchClick">查询</el-button>
            <span class="fr">&nbsp;&nbsp;&nbsp;</span>
            <el-button size="mini" type="info" icon="el-icon-delete" class="fr" @click="regionLineClearClick">清空</el-button>
          </td>
        </tr>
      </table>
      <table border="0" cellspacing="0" cellpadding="0" class="channel-line-list">
        <tr>
          <th style="width:260px;">渠道信息</th>
          <th style="width:90px;">参考时效</th>
          <th style="width:90px;">预计费用</th>
          <th>详情</th>
          <th style="width:120px;">操作</th>
          <th style="width:60px;"></th>
        </tr>
      </table>
      <table v-for="(item,index) in regionline.channellinelist" :key="index" border="0" cellspacing="0" cellpadding="0" class="channel-line-list">
        <template>
          <tr class="line-list">
            <td style="width:260px;">
              <div style="font-size:16px;color:#4b8de3;">{{item.EnterpriseName}}</div>
              <div style="color:#999999;">
                <router-link :to="{name:'channel',params:{channelid:item.ChannelId}}" tag="span">{{item.ChannelName}}</router-link>
                <i class="el-icon-question" style="color:#4b8de3;"></i></div>
              <div style="font-size:12px;">{{item.ShipmentRegion}}</div>
            </td>
            <td style="width:90px;">{{item.EstimatedStartDay}}-{{item.EstimatedEndDay}}天</td>
            <td style="width:90px;">￥{{item.TotalFee}}</td>
            <td style="font-size:12px;">
              <div>数量：{{item.TotalQuantity}},总重量：{{item.TotalWeight}} kg,总体积重：{{item.TotalVolumeWeight}} kg,总体积：{{item.TotalVolume}} m³</div>
              <div></div>
            </td>
            <td style="width:120px;">
              <router-link :to="{name:'create_delivery',params:{enterpriseid:'0',channelid:'0'}}">
                <template>
                  <el-button size="mini" type="primary">下单</el-button>
                </template>
              </router-link>
            </td>
            <td style="width:60px;">
              <span class="more" @click="moreClick(index,item)">
                <i :class="[item.ShowState?'el-icon-arrow-down':'el-icon-arrow-right']"></i></span>
            </td>
          </tr>
          <tr v-show="item.ShowState">
            <td colspan="6" style="border-top:1px solid #dbdbdb;">
              <table border="0" cellspacing="0" cellpadding="0" style="width:100%;">
                <tr v-for="(fee,i) in item.FeesList" :key="i" style="line-height:30px;">
                  <td>{{fee.PriceType}}</td>
                  <td>计费值：{{fee.BillingValue}}</td>
                  <td>标准价：{{fee.StandardPrice}}</td>
                  <td>折后价：{{fee.DiscountPrice}}</td>
                  <td>{{fee.FormulaString}}</td>
                  <td>{{fee.FormulaNote}}</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td colspan="6" class="label-td">
              <template v-for="(label,i) in item.LabelList">
                <i :key="i" class="el-icon-circle-check-outline label"></i>
                <span :key="i">{{label}}</span>
              </template>
            </td>
          </tr>
        </template>
      </table>
      <div style="line-height:40px; width:100%; text-align:center;">
        <span class="loading-more" @click="loadingMoreClick">加载更多</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activevalue: '0',
      activename: '地区',
      purposeregions: [
        { label: '美国', value: '0' },
        { label: '英国', value: '1' },
        { label: '日本', value: '2' },
      ],
      parcelattributes: [
        { label: '普货', value: '0' },
        { label: '带电', value: '1' },
        { label: '纯电池', value: '2' },
        { label: '液体', value: '3' },
        { label: '药品', value: '4' },
        { label: '食品', value: '5' },
        { label: '蔬果', value: '6' },
        { label: '粉末', value: '7' },
        { label: '膏体', value: '8' },
        { label: '化妆品', value: '9' },
        { label: '敏感货', value: '10' }
      ],
      regionline: {
        regions: [],
        shipmentlabel: '',
        shipmentid: '',
        purposelabel: '',
        purposeid: '',
        datalist: [],
        depottype: '0',
        depottypeshow: false,
        purposeregion: '',
        parcelattribute: '0',
        parcellist: [
          { long: 1, wide: 1, high: 1, weight: 0.5 }
        ],
        channellinelist: [
          {
            ChannelId:'0',
            ChannelName: '广州邮政小包',
            ShipmentRegion: '广州出口',
            EnterpriseName: '广州凯捷物流供应链',
            EstimatedStartDay: 5,
            EstimatedEndDay: 20,
            TotalFee: 1200.56,
            TotalQuantity: 2,
            TotalWeight: 5.5,
            TotalVolumeWeight: 5.4,
            TotalVolume: 2.7,
            ShowState: false,
            FeesList: [
              {
                PriceType: '运费',
                BillingValue: 5.5,
                StandardPrice: 1500,
                DiscountPrice: 1000,
                FormulaString: '（5.5*200）*0.9',
                FormulaNote: '不足1KG按1KG计费'
              },
              {
                PriceType: '报关费',
                BillingValue: 5.5,
                StandardPrice: 500,
                DiscountPrice: 200,
                FormulaString: '',
                FormulaNote: ''
              }
            ],
            LabelList: [
              '外箱贴有FBA二维码的货件，都必须做关税预付', '接报关件'
            ]
          }
        ]
      }
    }
  },
  methods: {
    linetypeClick (item) {
      console.log(item)
      this.activevalue = item.value
      this.activename = item.label
      this.regionline.shipmentid = ''
      this.regionline.purposeid = ''
      this.regionline.shipmentlabel = '起运' + item.label
      this.regionline.purposelabel = '目的' + item.label
      this.regionline.datalist = []
      this.regionline.depottypeshow = false
      switch (item.value) {
        case '1':
          this.regionline.datalist = [{ label: '白云国际机场', value: '0' }, { label: '伦敦国际机场', value: '1' }, { label: '洛杉矶国际机场', value: '2' }]
          break
        case '2':
          this.regionline.datalist = [{ label: '黄埔港', value: '0' }, { label: '英雄港', value: '1' }, { label: '迪亚曼泰港', value: '2' }]
          break
        case '3':
          this.regionline.depottypeshow = true
          this.depotTypeChange()
          break
        case '4':
          break
        default:
          break
      }
    },
    depotTypeChange () {
      this.regionline.datalist = []
      this.regionline.purposeid = ''
      switch (this.regionline.depottype) {
        case '0':
          this.regionline.datalist = [{ label: 'ABE2', value: '0' }, { label: 'ABE3', value: '1' }, { label: 'ABE4', value: '2' }]
          break
        case '1':
          this.regionline.datalist = [{ label: '伦敦仓', value: '0' }, { label: '洛杉矶仓', value: '1' }, { label: '纽约仓', value: '2' }]
          break
        case '2':
          this.regionline.datalist = [{ label: '莫斯科1仓', value: '0' }, { label: '莫斯科2仓', value: '1' }, { label: '莫斯科3仓', value: '2' }]
          break
        default:
          break
      }
    },
    insertRegionParcelClick () {
      this.regionline.parcellist.push({ long: 1, wide: 1, high: 1, weight: 0.5 })
    },
    deleteRegionParcelClick (index) {
      this.regionline.parcellist.splice(index, 1)
    },
    regionLineSearchClick () { },
    regionLineClearClick () {
      this.regionline.regions = []
      this.regionline.purposeregion = ''
      this.regionline.parcelattribute = '0'
      this.regionline.parcellist = [{ long: 1, wide: 1, high: 1, weight: 0.5 }]
    },
    moreClick (index, row) {
      row.ShowState = !row.ShowState
    },
    loadingMoreClick () {
      this.regionline.channellinelist.push(
        {
          ChannelName: '俄罗斯pony专线',
          ShipmentRegion: '广州出口',
          EnterpriseName: '广州腾汇国际',
          EstimatedStartDay: 5,
          EstimatedEndDay: 20,
          TotalFee: 1200.56,
          TotalQuantity: 3,
          TotalWeight: 5.5,
          TotalVolumeWeight: 5.4,
          TotalVolume: 2.7,
          ShowState: false,
          FeesList: [
            {
              PriceType: '运费',
              BillingValue: 5.5,
              StandardPrice: 1500,
              DiscountPrice: 1000,
              FormulaString: '（5.5*200）*0.9',
              FormulaNote: '不足1KG按1KG计费'
            },
            {
              PriceType: '报关费',
              BillingValue: 5.5,
              StandardPrice: 500,
              DiscountPrice: 200,
              FormulaString: '',
              FormulaNote: ''
            }
          ],
          LabelList: [
            '外箱贴有FBA二维码的货件，都必须做关税预付', '接报关件'
          ]
        }
      )
    }
  }
}
</script>

<style>
@import "../../css/home/home.css";

.channel-line-body {
  margin: 20px auto 20px auto;
  width: 1280px;
  min-height: 800px;
  background-color: #ffffff;
}

.channel-line-body .channel-line-category {
  list-style: none;
  padding: 0;
  border-bottom: 2px solid #f2f2f2;
  margin-bottom: 5px;
}
.channel-line-body .channel-line-category li {
  text-align: center;
  margin: 0 20px;
  line-height: 40px;
  cursor: pointer;
}

.channel-line-body .channel-line-category li.active {
  border-bottom: 2px solid #4b8de3;
}

.channel-line-body .channel-line-body-child {
  padding: 20px;
}

.channel-line-body .channel-line-search {
  margin: 0 auto;
  width: 800px;
  padding: 5px 0;
}

.channel-line-body .el-input-group--append .el-input__inner {
  padding: 0;
}

.channel-line-body .el-input-group__append,
.channel-line-body .el-input-group__prepend {
  border: 1px solid #dcdfe6;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  border-left: 0;
  padding: 0 5px;
}

.channel-line-body .channel-line-search ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.channel-line-body .channel-line-search ul li {
  padding: 5px 0;
}

.channel-line-body .channel-line-list {
  width: 100%;
  border-top: 0px solid #f2f2f2;
}

.channel-line-body .channel-line-list {
  width: 100%;
  border: 1px solid #dbdbdb;
  border-top: 0;
  text-align: center;
}

.channel-line-list th {
  line-height: 40px;
  color: #ffffff;
  font-size: 16px;
  background-color: #757575;
  padding: 0 5px;
}

.channel-line-list .line-list {
  height: 100px;
}

.line-list td {
  padding: 0 5px;
}

.channel-line-list .label-td {
  line-height: 40px;
  padding: 0 5px;
  color: #999999;
  background-color: #f6f6f6;
  border-top: 1px solid #dbdbdb;
}

.channel-line-list td .label {
  color: #4b8de3;
}

.channel-line-list .more {
  cursor: pointer;
}

.channel-line-body .loading-more {
  cursor: pointer;
  color: #4b8de3;
}
</style>



// WEBPACK FOOTER //
// src/components/home/channelline.vue